module.exports = __webpack_public_path__ + "media/images/emblems/Cazis_wappen-dec55bd77efd118b3d0e3a45c941096d.svg";